var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center p-4",attrs:{"id":"footer"}},[_vm._v(" © "+_vm._s(new Date().getFullYear())+" JKT Gateway. All Rights Reserved ")])
}
var staticRenderFns = []

export { render, staticRenderFns }